import { render, staticRenderFns } from "./Names.vue?vue&type=template&id=5565d988"
import script from "./Names.vue?vue&type=script&lang=js"
export * from "./Names.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports